
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';

const Mobile_not_seeded_int = () => {
  const [status, setStatus] = useState('');
  const [loadingGenerate, setLoadingGenerate] = useState(false);
  const [loadingGetLink, setLoadingGetLink] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [excelData, setExcelData] = useState([]);
  const [linkGenerated, setLinkGenerated] = useState(false);
  const [dataGeneratedMsg, setDataGeneratedMsg] = useState('');
  const [getLinkError, setGetLinkError] = useState(''); 

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_URL}/api/mobile-not-seeded/districts`, {
      withCredentials: true
    })
    .then(res => setDistricts(res.data))
    .catch(err => {
      console.error('Error fetching districts', err);
    });
  }, []);

  const handleGenerate = async () => {
    setLoadingGenerate(true);
    setStatus('');
    setExcelData([]);
    setLinkGenerated(false);
    setDataGeneratedMsg('');
    setGetLinkError(''); 

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}/api/mobile-not-seeded/generate`, 
        {}, 
        { withCredentials: true }
      );

      setStatus(res.data);

      if (res.data && res.data.toLowerCase().includes('download excel')) {
        const dataRes = await axios.get(
          `${process.env.REACT_APP_URL}/api/mobile-not-seeded/districts`,
          { withCredentials: true }
        );

        if (dataRes.data && dataRes.data.length > 0) {
          setDistricts(dataRes.data);
        }
      }
    } catch (error) {
      console.error('Generate error:', error);
      setStatus("Internal Exception");
    }

    setLoadingGenerate(false);
  };

  const handleGetLink = () => {
    if (!selectedDistrict) {
      alert('Please select a district');
      return;
    }

    setLoadingGetLink(true);
    setExcelData([]);
    setLinkGenerated(false);
    setDataGeneratedMsg('');
    setGetLinkError('');

    axios.get(`${process.env.REACT_APP_URL}/api/mobile-not-seeded/excel-data`, {
      params: { distCode: selectedDistrict },
      withCredentials: true
    })
    .then(res => {
      if (res.data && res.data.length > 0) {
        setExcelData(res.data);
        setLinkGenerated(true);
        setGetLinkError(''); 
      } else {
        setDataGeneratedMsg('No Data Found');
        setGetLinkError('');
      }
    })
    .catch(err => {
      console.error('Error fetching excel data', err);
      setGetLinkError('Internal Exception'); 
      setDataGeneratedMsg('');
    })
    .finally(() => setLoadingGetLink(false));
  };

  const downloadExcel = () => {
    const districtName = districts.find(d => d.distCode === selectedDistrict)?.distName || 'Selected District';

    const heading = `<tr><td colspan="7" style="font-weight: bold; background-color: orange; font-size: 16px; text-align: center;">
      Mobile Not Seeded Details ${districtName}
    </td></tr>`;

    const tableHtml = `
      <table border="1">
        <thead>
          ${heading}
          <tr style="background-color: orange; font-weight: bold;">
            <td>Sl No</td>
            <td>District</td>
            <td>Office</td>
            <td>FPS Id</td>
            <td>RC Id</td>
            <td>Scheme</td>
            <td>Units</td>
          </tr>
        </thead>
        <tbody>
          ${excelData.map((row, index) => `
            <tr>
              <td>${index + 1}</td>
              <td>${row.district}</td>
              <td>${row.office}</td>
              <td style="mso-number-format:'\\@';">${row.fpsId}</td>
              <td style="mso-number-format:'\\@';">${row.rcId}</td>
              <td>${row.scheme}</td>
              <td>${row.units}</td>
            </tr>`).join('')}
        </tbody>
      </table>
    `;

    const blob = new Blob([tableHtml], { type: 'application/vnd.ms-excel' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Mobile Not Seeded Details in ${districtName}.xls`;
    a.click();
  };

  return (
    <form>
      <table width="35%" align="center" style={{marginTop:"15px"}}>
        <tbody>
          <tr className="tableheader">
            <td colSpan="2" align="center">Mobile Not Seeded Details</td>
          </tr>

          <tr>
            <td colSpan="2" align="center">
              <button 
                type="button" 
                className="button button2" 
                onClick={handleGenerate}
              >
                Generate Mobile Not Seeded Details
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      {loadingGenerate && (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <CircularProgress/>
        </div>
      )}

      {status && (
        <div align="center" style={{ margin: '20px', fontWeight: 'bold', color: 'brown', textDecoration: 'underline' }}>
          {status}
        </div>
      )}

      {(status.includes('generated') || status.includes('Data')) && (
        <>
          <table width="35%" align="center">
            <tbody>
              <tr className="tableheader">
                <td colSpan="3" align="center">Mobile Not Seeded Details</td>
              </tr>
              <tr>
                <td>District</td>
                <td>
                  <select 
                    value={selectedDistrict} 
                    onChange={e => setSelectedDistrict(e.target.value)}
                  >
                    <option value="">--Select--</option>
                    {districts.map((d, idx) => (
                      <option key={idx} value={d.distCode}>
                        {d.distName}
                      </option>
                    ))}
                  </select>
                </td>
                <td>
                  <button 
                    type="button" 
                    className="button button2" 
                    onClick={handleGetLink}
                    disabled={!selectedDistrict}
                  >
                    Get Link
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          {loadingGetLink && (
            <div style={{ textAlign: 'center', marginTop: '15px' }}>
              <CircularProgress/>
            </div>
          )}

          {getLinkError && (
            <div align="center" style={{ 
              margin: '20px', 
              fontWeight: 'bold', 
              color: 'brown', 
              textDecoration: 'underline' 
            }}>
              {getLinkError}
            </div>
          )}

          {linkGenerated && selectedDistrict && (
            <div align="center" style={{ margin: '35px' }}>
              <a
                href="#"
                onClick={e => {
                  e.preventDefault();
                  downloadExcel();
                }}
                style={{ fontWeight: 'bold', color: 'blue', textDecoration: 'underline' }}
              >
                Mobile Not Seeded Details in {
                  districts.find(d => d.distCode === selectedDistrict)?.distName || ''
                }
              </a>
            </div>
          )}

          {dataGeneratedMsg && (
            <div align="center" style={{ color: 'red', marginTop: '10px' }}>
              {dataGeneratedMsg}
            </div>
          )}
        </>
      )}
    </form>
  );
};

export default Mobile_not_seeded_int;